import React from "react";
import { connect } from "react-redux";
import Loading from "./Loading";
import TerritoryContent from "./TerritoryContent";
import TerritoryMenu from "./TerritoryMenu";
import { selectTerritoryProgram } from "../functionality/actions/territoryActions";

function TerritoryProgram(props) {
  const {
    territoryReducer: {
      territory_loading_programs,
      territory_programs,
      territory_program,
      territory_index,
    },
    selectTerritoryProgram,
  } = props;

  if (territory_loading_programs || !territory_programs) {
    return (
      <>
        <br />
        <Loading />
      </>
    );
  }

  return (
    <>
      <TerritoryMenu
        menu={territory_programs}
        selected={territory_program}
        onChange={selectTerritoryProgram}
        value={territory_index}
      />
      <TerritoryContent information={territory_program} user_validate={true} />
    </>
  );
}

const mapStateToProps = ({ territoryReducer }) => {
  return {
    territoryReducer,
  };
};

const mapDispatchProps = {
  selectTerritoryProgram,
};

export default connect(mapStateToProps, mapDispatchProps)(TerritoryProgram);
